<template>
    <div class="md-card" v-on:fetchData="fetchData">
        <modal
            v-if="modalPedirMaterial"
            @close="showModalMaterial"
            modalSize="modal-container-sm"
        >
            <template slot="header">
                <h4 class="modal-title">{{ $t("pedir_material") }}</h4>
                <md-button
                    class="md-simple md-just-icon md-round modal-default-button"
                    @click="showModalMaterial"
                >
                    <md-icon>clear</md-icon>
                </md-button>
            </template>
            <template slot="body">
                <md-card>
                    <md-card-content>
                        <div class="md-layout-item md-size-100">
                            <md-field>
                                <label>{{ $t("sensors") }}</label>
                                <md-input
                                    v-model="sensors"
                                    type="number"
                                    min="0"
                                    max="100"
                                ></md-input>
                            </md-field>
                            <md-field>
                                <label>{{ $t("stickers") }}</label>
                                <md-input
                                    v-model="stickers"
                                    type="number"
                                    min="0"
                                    max="100"
                                ></md-input>
                            </md-field>
                        </div>
                    </md-card-content>
                </md-card>
            </template>

            <template slot="footer">
                <md-button
                    class="md-danger md-simple"
                    @click="showModalMaterial"
                    >{{ $t("cancel") }}
                </md-button>
                <md-button @click="pedirMaterial()" class="md-success"
                    >{{ $t("save") }}
                </md-button>
            </template>
        </modal>
        <md-card-header class="md-card-header-icon md-card-header-green">
            <div class="card-icon">
                <md-icon>inventory</md-icon>
            </div>
            <md-card-header-text>
                <h4 class="title">{{ $t("pedir_material") }}</h4>
                <div class="pull-right">
                    <md-button class="md-success" @click="showModalMaterial()">
                        {{ $t("pedir_material") }}
                    </md-button>
                </div>
            </md-card-header-text>
        </md-card-header>
        <div class="md-card-content">
            <md-table table-header-color="green">
                <md-table-row>
                    <md-table-head>ID</md-table-head>
                    <md-table-head>{{ $t("cliente") }}</md-table-head>
                    <md-table-head>{{ $t("fecha_registro") }}</md-table-head>
                    <md-table-head>{{ $t("stickers") }}</md-table-head>
                    <md-table-head>{{ $t("sensors") }}</md-table-head>
                </md-table-row>
                <md-table-row
                    v-for="(data, i) in orders"
                    :key="i"
                    slot="md-table-row"
                >
                    <md-table-cell>{{ data.id }}</md-table-cell>
                    <md-table-cell>{{ data.centro }}</md-table-cell>
                    <md-table-cell>{{ data.fecha }}</md-table-cell>
                    <md-table-cell>{{ data.rollos }}</md-table-cell>
                    <md-table-cell>{{ data.sensores }}</md-table-cell>
                </md-table-row>
            </md-table>
        </div>
    </div>
</template>
<script>
import { authHeader } from "../../helpers/auth-header";
import { handleResponse } from "../../helpers/handle-response";
import Modal from "../../components/Modal";

let BACKEND_API = process.env.VUE_APP_BACKEND_API;
export default {
    data() {
        return {
            modalPedirMaterial: false,
            sensors: 0,
            stickers: 0,
            orders: [],
        };
    },
    components: {
        Modal,
    },
    created() {
        this.fetchData();
    },
    methods: {
        showModalMaterial() {
            this.modalPedirMaterial = !this.modalPedirMaterial;
        },
        pedirMaterial() {
            //Check if sensors or stickers are 0
            if (this.sensors == 0 && this.stickers == 0) {
                this.$swal({
                    title: this.$t("error_formulario"),
                    text: this.$t("material_required"),
                    icon: "error",
                    button: this.$t("ok"),
                });
                return;
            }
            let url = `${BACKEND_API}/api/pacientes/pedirMaterial`;
            let currentCentro = JSON.parse(sessionStorage.getItem("idCentro"));
            if (currentCentro) {
                url = `${BACKEND_API}/api/pacientes/pedirMaterial?idCentro=${currentCentro.id}`;
            }
            fetch(url, {
                method: "POST",
                headers: authHeader(),
                body: JSON.stringify({
                    sensors: this.sensors,
                    stickers: this.stickers,
                }),
            })
                .then(handleResponse)
                .then((response) => {
                    //Create a swal that says operation completed successfully
                    this.modalPedirMaterial = false;
                    this.sensors = 0;
                    this.stickers = 0;
                    this.$swal({
                        title: this.$t("success"),
                        text: this.$t("material_requested"),
                        icon: "success",
                        button: this.$t("ok"),
                    });
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        fetchData() {
            let self = this;
            let url = `${BACKEND_API}/api/pacientes/orders`;
            let currentCentro = JSON.parse(sessionStorage.getItem("idCentro"));
            if (currentCentro) {
                url = `${BACKEND_API}/api/pacientes/orders?idCentro=${currentCentro.id}`;
            }
            this.sections = [];
            this.response = [];
            fetch(url, {
                method: "GET",
                headers: authHeader(),
            })
                .then(handleResponse)
                .then((response) => {
                    self.orders = response;
                    self.isLoading = false;
                });
        },
    },
};
</script>
